var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible",
          },
        ],
        staticClass: "back-to-top",
        style: {
          right: _vm.mobile ? "10px" : "40px",
          bottom: _vm.mobile ? "70px" : "40px",
          width: _vm.mobile ? "40px" : "50px",
          height: _vm.mobile ? "40px" : "50px",
        },
        on: { click: _vm.scrollToTarget },
      },
      [
        _c("svg", { staticClass: "icon", attrs: { viewBox: "0 0 24 24" } }, [
          _c("path", {
            attrs: {
              d: _vm.showBackToTop
                ? "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
                : "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z",
            },
          }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }